import React from "react";
import { Dialog, DialogContent, Typography, Button } from "@mui/material";
import { theme } from "../../theme/colors";

/** Shown when user tries to follow or view profile for someone without a CivixThread account. */
export default function NoCivixAccountModal({ open, onClose, displayName }) {
  const name = displayName || "This person";
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: "16px", textAlign: "center", p: 1 } }}
    >
      <DialogContent>
        <Typography sx={{ fontWeight: 700, fontSize: 18, mb: 1, color: "#0f172a" }}>
          No CivixThread Account
        </Typography>
        <Typography sx={{ fontSize: 15, color: "#334155", mb: 1 }}>
          {name} hasn&apos;t joined CivixThread yet.
        </Typography>
        <Typography sx={{ fontSize: 14, color: "#64748b", mb: 3, lineHeight: 1.5 }}>
          When they create an account, you&apos;ll be able to follow them and see their posts.
        </Typography>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            borderRadius: "20px",
            px: 4,
            fontWeight: 700,
            textTransform: "none",
            background: theme.gradient,
            "&:hover": { opacity: 0.9, background: theme.gradient },
          }}
        >
          Got it
        </Button>
      </DialogContent>
    </Dialog>
  );
}
